// extracted by mini-css-extract-plugin
module.exports = {"search":"WeatherSearch_search__1CKon","srchIcon":"WeatherSearch_srchIcon__1ZyH6","search2":"WeatherSearch_search2__1gWs9"};